import React from 'react';
import IdentityLink from './IdentityLink';
import { formatDecimal, formatDocument } from './contract';
import { amountColumn, kmColumn, pcpColumn, updatedColumn, windowColumn } from './listColumns';
import StageList from './StageList';
import { placeLabel, titleCase, upperCase } from './text';

const missing = 'Não informado';
const names = (items) =>
  (items || [])
    .map((item) => titleCase(item.name))
    .filter(Boolean)
    .join(' / ');
// 5674: textos como nos cards (5663); cliente em maiúsculas e UF com duas letras.
const place = (point) => placeLabel(point) || missing;
// 5667: ordem do modelo novo, com KM Total, janelas, Carroceria, Atualizado e PCP.
const columns = [
  {
    key: 'position',
    label: '#',
    width: 44,
    resizable: false,
    value: (_, i) => String(i + 1).padStart(2, '0'),
  },
  {
    key: 'load',
    label: 'Carga',
    width: 130,
    value: (row) => String(row.id),
    render: (row, value) => (
      <IdentityLink
        to={`${row.type === 'PRE_LOAD' ? '/pre-cargas' : '/cargas'}/${row.loadId ?? row.id}`}
        aria-label={`Abrir ${row.type === 'PRE_LOAD' ? 'pré-carga' : 'carga'} ${row.id}`}
      >
        {value}
      </IdentityLink>
    ),
  },
  {
    key: 'client',
    label: 'Cliente',
    width: 220,
    value: (row) =>
      `${upperCase(row.client?.name) || 'Cliente não informado'} · ${formatDocument(row.client?.cnpj)}`,
  },
  {
    key: 'product',
    label: 'Produto',
    width: 160,
    value: (row) =>
      [
        titleCase(row.product?.name) || missing,
        row.quantity?.weight != null ? `${formatDecimal(row.quantity.weight)} kg` : null,
        row.quantity?.volume != null ? `Volume: ${row.quantity.volume}` : null,
        row.quantity?.pallets != null ? `Pallets: ${row.quantity.pallets}` : null,
      ]
        .filter(Boolean)
        .join(' · '),
  },
  amountColumn,
  { key: 'origin', label: 'Origem', width: 155, value: (row) => place(row.origin) },
  { key: 'destination', label: 'Destino', width: 155, value: (row) => place(row.destination) },
  kmColumn('km', 'KM Total', (row) => row.totalDistanceMeters),
  windowColumn(
    'pickup',
    'Coleta Agendada',
    (row) => row.scheduledPickupStartAt,
    (row) => row.scheduledPickupAt,
  ),
  windowColumn(
    'delivery',
    'Entrega Agendada',
    (row) => row.scheduledDeliveryStartAt,
    (row) => row.scheduledDeliveryAt,
  ),
  {
    key: 'vehicle',
    label: 'Veículo',
    width: 170,
    value: (row) =>
      [names(row.vehicleProfile?.vehicleTypes), names(row.vehicleProfile?.implementTypes)]
        .filter(Boolean)
        .join(' · ') || missing,
  },
  {
    key: 'body',
    label: 'Carroceria',
    width: 140,
    value: (row) => names(row.vehicleProfile?.bodyTypes) || missing,
  },
  {
    key: 'tracking',
    label: 'Rastreado',
    width: 130,
    value: (row) =>
      [
        row.tracking?.required === true
          ? 'Sim'
          : row.tracking?.required === false
            ? 'Não'
            : missing,
        titleCase(row.tracking?.tracker?.name),
      ]
        .filter(Boolean)
        .join(' · '),
  },
  {
    key: 'observations',
    label: 'Observações',
    width: 235,
    value: (row) =>
      [row.observations?.comments, row.observations?.additionalInfo].filter(Boolean).join(' · ') ||
      missing,
  },
  updatedColumn,
  pcpColumn,
];

const definition = {
  code: 'AVAILABLE',
  title: 'PRÉ CARGAS / CARGAS',
  className: 'tc-k-load-list',
  loadingLabel: 'pré-cargas e cargas',
  tableLabel: 'Lista de pré-cargas e cargas',
  emptyMessage: 'Nenhuma pré-carga ou carga disponível.',
};
export default function AvailableList(props) {
  return <StageList {...props} definition={definition} columns={columns} />;
}
